import {
  Box,
  Container,
  CssBaseline,
  Grid,
  Paper,
  ThemeProvider,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material";
import theme from "../../../config/theme";
import connected from "../../../assets/connected.png";
import execution from "../../../assets/execution.png";
import view from "../../../assets/view.png";

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
}));

const StyledBox = styled(Box)({
  marginTop: "2.375rem",
  display: "flex",
  justifyContent: "center",
});

const StyledTypography = styled(Typography)({
  fontWeight: "700",
  fontSize: "1.375rem",
  color: "#212121",
});

const StyledBox2 = styled(Box)({
  marginTop: "2rem",
  marginBottom: "2rem",
  display: "flex",
  justifyContent: "center",
});

const StyledTypography2 = styled(Typography)({
  width: "17rem",
  letterSpacing: "0.01rem",
  fontSize: "1.125rem",
  color: "#212121",
});

const gridData = [
  {
    imgSrc: connected,
    title: "Staying Connected",
    subtitle:
      "Stay connected and on top! No more missed updates or scheduling woes.",
  },
  {
    imgSrc: execution,
    title: "Seamless Execution",
    subtitle:
      "Transform your academy with a click - Say bye-bye to chaos, hello to simplicity!",
  },
  {
    imgSrc: view,
    title: "Panoramic View",
    subtitle:
      "Rise above the chaos with a clear view of all your organization's activities.",
  },
];

const Why = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container>
        {isMobile ? (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Typography
              variant="h3"
              sx={{
                marginTop: "3.75rem",
                fontSize: "1.375rem",
                fontWeight: 700,
                textAlign: "center",
                "& span": {
                  color: "#212121",
                },
                "& span.blue": {
                  color: theme.palette.primary.main,
                },
              }}
            >
              <span>Why</span> <span className="blue">Youstad?</span>
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Typography
              variant="h3"
              sx={{
                marginTop: "7.5rem",
                fontSize: "2.75rem",
                fontWeight: 700,
                textAlign: "center",
                "& span": {
                  color: "#212121",
                },
                "& span.blue": {
                  color: theme.palette.primary.main,
                },
              }}
            >
              <span>Why</span> <span className="blue">Youstad?</span>
            </Typography>
          </Box>
        )}

        <Box sx={{ marginTop: "3.75rem" }}>
          <Grid container spacing={2}>
            {gridData.map((item, index) => (
              <Grid
                item
                xs={12}
                md={4}
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Item
                  sx={{
                    flex: "1 1 0",
                    cursor: "pointer",
                    boxShadow: " 0px 8px 24px rgba(88, 101, 242, 0.15)",
                    borderRadius: "1.25rem",
                  }}
                >
                  <Box sx={{ marginTop: "2rem" }}>
                    <img
                      src={item.imgSrc}
                      alt=""
                      style={{
                        height: "3.625rem",
                        width: "3.625rem",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                  <StyledBox>
                    <StyledTypography variant="h5">
                      {item.title}
                    </StyledTypography>
                  </StyledBox>
                  <StyledBox2 sx={{ flex: "1 1 0" }}>
                    <StyledTypography2 variant="h6">
                      {item.subtitle}
                    </StyledTypography2>
                  </StyledBox2>
                </Item>
              </Grid>
            ))}
          </Grid>
        </Box>

        {isMobile ? (
          <Box
            sx={{
              marginTop: "3.75rem",
              marginBottom: "2.5rem",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                width: "100%",
                fontSize: "0.75rem",
                fontWeight: 700,
                letterSpacing: "0.015625rem",
                textAlign: "center",
                "& span": {
                  color: "#212121",
                },
                "& span.blue": {
                  color: theme.palette.primary.main,
                },
              }}
            >
              <span>Discover the</span>{" "}
              <span className="blue">unparalleled efficiency</span>{" "}
              <span>and</span> <span className="blue">quick results</span>{" "}
              <span>of Youstad, the ultimate education experience</span>
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "3.75rem",
              marginBottom: "6.8125rem",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                width: "59.94rem",
                fontSize: "1.8125rem",
                fontWeight: 700,
                letterSpacing: "0.015625rem",
                textAlign: "center",
                lineHeight: "2.5rem",
                "& span": {
                  color: "#212121",
                },
                "& span.blue": {
                  color: theme.palette.primary.main,
                },
              }}
            >
              <span>Discover the</span>{" "}
              <span className="blue">unparalleled efficiency</span>{" "}
              <span>and</span> <span className="blue">quick results</span>{" "}
              <span>of Youstad, the ultimate education experience</span>
            </Typography>
          </Box>
        )}
      </Container>
    </ThemeProvider>
  );
};

export default Why;
